
import userInfoPage from "./userInfoPage.vue";

export default [userInfoPage];
